import { FC, SVGProps } from 'react';
import cn from 'classnames';
import { LoaderIcon } from '../icons/loader';
import './loader.styles.scss';

export const Loader: FC<SVGProps<SVGSVGElement>> = (props) => {
  const loaderProps: SVGProps<SVGSVGElement> = {
    ...props,
    className: cn(
      props.className,
      'loader',
    ),
  };

  return (
    <LoaderIcon {...loaderProps} />
  );
};
